import styled from "styled-components";
import { Popover } from "@material-ui/core";

export const STNotificationText = styled.span`
  top: 30px;
  right: 8px;
  color: #fff;
  height: 8px;
  width: 8px;
  display: block;
  position: absolute;
  font-size: 10px;
  background: #f44336;
  text-align: center;
  line-height: 16px;
  border-radius: 10px;
  vertical-align: middle;
  font-weight: bold;
`;

export const STPopover = styled(Popover)`
  && {
    > div[role="document"] {
      right: 16px !important;
      left: auto !important;
    }
  }
`;
